module.exports = __webpack_public_path__ + "img/1dd5dec.png";